import { PageListCachedDataSource } from './BaseDataSources';
import { ICountry } from '../Interfaces';

export class CountrySource extends PageListCachedDataSource<ICountry> {
  public constructor() {
    super('/datasource/countries');
  }
}